export const ComponentsDatabse = [
  "Button",
  "Avatar",
  "Alert",
  // "Toast",
  "Checkbox",
  "Badge",
  // "Card",
  "Image",
  "Input",
  "List"
];
